import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { queryClient, queryKeys } from '../../../../utils/react-query';
import { ConfirmDialog } from '../../../../components/confirmDialog';

import { MenuDropdownButton } from './styledComponents';
import { useDeleteRegistration } from './hooks/useDeleteRegistration';

interface Props {
  registreringId: string;
  buildingId?: string;
}

export const DeleteButton: FC<Props> = ({ registreringId, buildingId }) => {
  const [isConfirmDialogOpen, setConfirmDialogOpen] = React.useState(false);
  const { deleteRegistration, isLoading: isDeleting } = useDeleteRegistration();
  const { t } = useTranslation('', { keyPrefix: 'screens.energiplan.components.tilstandMenu' });

  const onDelete = () => {
    deleteRegistration(registreringId, {
      onSuccess: () => queryClient.invalidateQueries([queryKeys.building, buildingId])
    });
  };
  return (
    <>
      <MenuDropdownButton disabled={isDeleting} onClick={() => setConfirmDialogOpen(true)}>
        {t('deleteButton')}
      </MenuDropdownButton>
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onConfirm={onDelete}
        onCancel={() => setConfirmDialogOpen(false)}
        title={t('deleteDialogTitle')}
        content={t('deleteDialogContent')}
        isLoading={isDeleting}
      />
    </>
  );
};
